'use strict';

const gallery = {
  slides: [],
  currentSlide: 0,
  slideInterval: null,
  intervalDuration: 2000,
  playing: true,
  pauseButton: document.querySelector('.gallery-slider__pause-button'),
  previousButton: document.querySelector('.gallery-slider__previous-button'),
  nextButton: document.querySelector('.gallery-slider__next-button'),
  playText: '<i class="fa fa-play" aria-hidden="true"></i>',
  pauseText: '<i class="fa fa-pause" aria-hidden="true"></i>',
  previousText: '<i class="fa fa-step-backward" aria-hidden="true"></i>',
  nextText: '<i class="fa fa-step-forward" aria-hidden="true"></i>',
  init() {
    this.slides = document.querySelectorAll('.gallery-slider .gallery-slider__slide');
    this.slideInterval = setInterval(this.nextSlide.bind(this), this.intervalDuration);

    this.pauseButton.innerHTML = (this.playing) ? this.pauseText : this.playText;
    this.previousButton.innerHTML = this.previousText;
    this.nextButton.innerHTML = this.nextText;

    this.pauseButton.onclick = () => {
      if (this.playing) {
        this.pauseSlideshow();
      } else {
        this.playSlideshow();
      }
    };

    this.previousButton.onclick = () => {
      this.pauseSlideshow();
      this.previousSlide();
    };

    this.nextButton.onclick = () => {
      this.pauseSlideshow();
      this.nextSlide();
    };
  },
  nextSlide() {
    this.goToSlide(this.currentSlide + 1);
  },
  previousSlide() {
    this.goToSlide(this.currentSlide - 1);
  },
  goToSlide(n) {
    this.slides[this.currentSlide].className = 'gallery-slider__slide';
    this.currentSlide = (n + this.slides.length) % this.slides.length;
    this.slides[this.currentSlide].className = 'gallery-slider__slide gallery-slider__slide--showing';
  },
  pauseSlideshow() {
    this.pauseButton.innerHTML = this.playText;
    this.playing = false;
    clearInterval(this.slideInterval);
  },
  playSlideshow() {
    this.pauseButton.innerHTML = this.pauseText;
    this.playing = true;
    this.slideInterval = setInterval(this.nextSlide.bind(this), this.intervalDuration);
  }
};

export default gallery;
